module.exports = __webpack_public_path__ + "img/bikeblue.84d2c120.png";